import { createSlice } from '@reduxjs/toolkit';

export interface TwoFAActivateModalSliceState {
  isOpen: boolean;
}

const initialState: TwoFAActivateModalSliceState = {
  isOpen: false,
};

const twoFAActivateModalSlice = createSlice({
  name: 'twoFAActivateModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export { twoFAActivateModalSlice };
